
/**
 * @export
 * @enum {string}
 */
export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}